import { createSlice } from '@reduxjs/toolkit'
import { PayloadAction } from '@reduxjs/toolkit'

import { OrganizationTags } from 'models/OrganizationTags'

// Define the initial state for the slice
const initialState: OrganizationTags = {
  skipOptimizely: false,
}

export const organizationTagsSlice = createSlice({
  name: 'organizationTags',
  initialState,
  reducers: {
    setOrganizationTags: (state, action: PayloadAction<OrganizationTags>) => {
      return action.payload
    },
  },
})

export const { setOrganizationTags } = organizationTagsSlice.actions

// Export the reducer
export default organizationTagsSlice.reducer
